import { Route as AuthorizedRoute, Routes, Navigate } from "react-router-dom";

/*Component Import*/
import Dashboard from "./Dashboard";
import Programs from "./Programs";
import AddProgram from "./AddProgram";
import ProgramStructure from "./ProgramStructure";
import Tenders from "./Tenders";
import TendersV2 from "./TendersV2";
import TenderDetails from "./TenderDetails";
import AddTender from "./AddTender";
import EditProgram from "./EditProgram";
import UserRolesAuthorisation from "./UserRolesAuthorisation";
import AddUserRolesAuthorisation from "./AddUserRolesAuthorisation";
import AddUserFakultetaRolesAuthorisation from "./AddUserFakultetaRolesAuthorisation";
import EditUserRolesAuthorisation from "./EditUserRolesAuthorisation";
import EditUserFakultetaRolesAuthorisation from "./EditUserFakultetaRolesAuthorisation";
import Revision from "./Revision";
import CodeList from "./CodeList";
import ProjectPartners from "./ProjectPartners";
import ProjectPartnersV2 from "./ProjectPartnersV2";
import AddProjectPartner from "./AddProjectPartner";
import ProjectPartnerDetails from "./ProjectPartnerDetails";
import AddOrgUnit from "./AddOrgUnit";
import EditOrgUnit from "./EditOrgUnit";
import AddProject from "./AddProject";
import ProjectDetails from "./ProjectDetails";
import Projects from "./Projects";
import ProjectsV2 from "./ProjectsV2";
import Reports from "./Reports";
import ReportsClanice from "./ReportsClanice";
import CurrentTenders from "./CurrentTenders";
import Deminimis from "./Deminimis";
import DeminimisAddPage from "./DeminimisAddPage";
import DeminimisDetailsPage from "./DeminimisDetailsPage";
import Partnerstva from "./Partnerstva";
import KontaktiUM from "./KontaktiUM";

import ProjectDetailsV2 from "./ProjectDetailsV2";
import Splosno from "./projectDetailsV2/splosno/Splosno";
import Partnerstvo from "./projectDetailsV2/partnerstvo/Partnerstvo";
import Finance from "./projectDetailsV2/finance/Finance";
import PartnerskeOrganizacije from "./projectDetailsV2/partnerstvo/partnerskeOrganizacije/PartnerskeOrganizacije";
import SodelovanjeZnotrajUM from "./projectDetailsV2/partnerstvo/sodelovanjeZnotrajUM/SodelovanjeZnotrajUM";
import NacrtovanaVrednostProjekta from "./projectDetailsV2/finance/nacrtovanaVrednostProjekta/NacrtovanaVrednostProjekta";
import RealiziranaVrednostProjekta from "./projectDetailsV2/finance/realiziranaVrednostProjekta/RealiziranaVrednostProjekta";
import StroskovnaMesta from "./projectDetailsV2/finance/stroskovnaMesta/StroskovnaMesta";
import DeminimisProjectDetails from "./projectDetailsV2/finance/deminimis/DeminimisProjectDetails";
import RoleGuard from "../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../auth/roles";

/*React-bootstrap components */
import Col from "react-bootstrap/Col";

const AuthorisationComponent = ({ role }) => {
  let routes;
  let vloga = "uporabnik";

  if (role.admin === true) {
    vloga = "superAdmin";
  }

  switch (vloga) {
    case "uporabnik":
      routes = (
        <Routes>
          <AuthorizedRoute
            exact
            path="/DashboardBeta"
            element={<Dashboard role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Programi"
            element={<Programs role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Programi/DodajProgram/:id?/"
            element={<AddProgram role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Programi/UrediProgram/:id"
            element={<EditProgram role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Programi/Struktura/:id"
            element={<ProgramStructure role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Razpisi"
            element={<Tenders role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/RazpisiV2"
            element={<TendersV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/RazpisPodrobnosti/:id"
            element={<TenderDetails role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Razpisi/DodajRazpis/:id?"
            element={<AddTender role={role} />}
          />

          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji"
            element={<ProjectPartners role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerjiV2"
            element={<ProjectPartnersV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji/Dodaj"
            element={<AddProjectPartner role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji/Podrobnosti/:id"
            element={<ProjectPartnerDetails role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji/Enota/Dodaj/:id"
            element={<AddOrgUnit role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji/Enota/Uredi/:id"
            element={<EditOrgUnit role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Projekti/DodajProjekt"
            element={<AddProject role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Projekti/Podrobnosti/:id"
            element={<ProjectDetails role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Projekti"
            element={<Projects role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektiV2"
            element={<ProjectsV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektiV2/ORUD"
            element={<ProjectsV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektiV2/Clanica"
            element={<ProjectsV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Partnerstva"
            element={<Partnerstva />}
          />
          <AuthorizedRoute
            exact
            path="/KontaktiUM"
            element={<KontaktiUM />}
          />
          <AuthorizedRoute
            exact
            path="/Sifranti"
            element={
              <RoleGuard moduleKey={MODULES.SIFRANTI} roles={ROLE_GROUPS.GLOBALNI}>
                <CodeList role={role} />
              </RoleGuard>
            }
          />
          <AuthorizedRoute
            exact
            path="/izpisiClanice"
            element={<ReportsClanice />}
          />
          <AuthorizedRoute
            exact
            path="/AktualniRazpisi"
            element={<CurrentTenders role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis"
            element={<Deminimis role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Dodaj"
            element={<DeminimisAddPage role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Podrobnosti/:id"
            element={<DeminimisDetailsPage role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Projekti/Podrobnostiv2/:id"
            element={<ProjectDetailsV2 role={role} />}
          >
            <AuthorizedRoute
              index
              element={<Navigate to="splosno" replace />}
            />
            <AuthorizedRoute path="Splosno" element={<Splosno />} />
            <AuthorizedRoute path="Partnerstvo" element={<Partnerstvo />}>
              <AuthorizedRoute
                index
                element={<Navigate to="partnerske-organizacije" replace />}
              />
              <AuthorizedRoute
                path="partnerske-organizacije"
                element={<PartnerskeOrganizacije />}
              />
              <AuthorizedRoute
                path="sodelovanje-znotraj-um"
                element={<SodelovanjeZnotrajUM />}
              />
            </AuthorizedRoute>
            <AuthorizedRoute path="Finance" element={<Finance />}>
              <AuthorizedRoute
                index
                element={<Navigate to="nacrtovana-vrednost-projekta" replace />}
              />
              <AuthorizedRoute
                path="nacrtovana-vrednost-projekta"
                element={<NacrtovanaVrednostProjekta />}
              />
              <AuthorizedRoute
                path="realizirana-vrednost-projekta"
                element={<RealiziranaVrednostProjekta />}
              />
              <AuthorizedRoute
                path="stroskovna-mesta"
                element={<StroskovnaMesta />}
              />
              <AuthorizedRoute
                path="deminimis"
                element={<DeminimisProjectDetails />}
              />
            </AuthorizedRoute>
          </AuthorizedRoute>
          <AuthorizedRoute
            exact
            path="/Deminimis"
            element={<Deminimis role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Skrbnistvo"
            element={<Deminimis role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Dodaj"
            element={<DeminimisAddPage role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Podrobnosti/:id"
            element={<DeminimisDetailsPage role={role} />}
          />
        </Routes>
      );
      break;
    case "superAdmin":
      routes = (
        <Routes>
          <AuthorizedRoute
            exact
            path="/DashboardBeta"
            element={<Dashboard role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Avtorizacije"
            element={<UserRolesAuthorisation />}
          />
          <AuthorizedRoute
            exact
            path="/Avtorizacije/Dodaj"
            element={<AddUserRolesAuthorisation />}
          />
          <AuthorizedRoute
            exact
            path="/Avtorizacije/DodajFakultetnega"
            element={<AddUserFakultetaRolesAuthorisation />}
          />
          <AuthorizedRoute
            exact
            path="/Avtorizacije/uredi/:id"
            element={<EditUserRolesAuthorisation />}
          />
          <AuthorizedRoute
            exact
            path="/Avtorizacije/uredi/fakultetni/:id"
            element={<EditUserFakultetaRolesAuthorisation />}
          />
          <AuthorizedRoute
            exact
            path="/Zgodovina-sprememb"
            element={<Revision />}
          />
          <AuthorizedRoute exact path="/Sifranti" element={<CodeList />} />
          <AuthorizedRoute
            exact
            path="/Programi"
            element={<Programs role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Programi/DodajProgram/:id?/"
            element={<AddProgram role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Programi/UrediProgram/:id"
            element={<EditProgram role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Programi/Struktura/:id"
            element={<ProgramStructure role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Razpisi"
            element={<Tenders role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/RazpisiV2"
            element={<TendersV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/RazpisPodrobnosti/:id"
            element={<TenderDetails role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Razpisi/DodajRazpis/:id?"
            element={<AddTender role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji"
            element={<ProjectPartners role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerjiV2"
            element={<ProjectPartnersV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji/Dodaj"
            element={<AddProjectPartner role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji/Podrobnosti/:id"
            element={<ProjectPartnerDetails role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji/Enota/Dodaj/:id"
            element={<AddOrgUnit role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektniPartnerji/Enota/Uredi/:id"
            element={<EditOrgUnit role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Projekti/DodajProjekt"
            element={<AddProject role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Projekti/Podrobnosti/:id"
            element={<ProjectDetails role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Projekti"
            element={<Projects role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektiV2"
            element={<ProjectsV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektiV2/ORUD"
            element={<ProjectsV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/ProjektiV2/Clanica"
            element={<ProjectsV2 role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Partnerstva"
            element={<Partnerstva />}
          />
          <AuthorizedRoute
            exact
            path="/KontaktiUM"
            element={<KontaktiUM />}
          />
          <AuthorizedRoute exact path="/izpisi" element={<Reports />} />
          <AuthorizedRoute
            exact
            path="/izpisiClanice"
            element={<ReportsClanice />}
          />
          <AuthorizedRoute
            exact
            path="/AktualniRazpisi"
            element={<CurrentTenders role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis"
            element={<Deminimis role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Dodaj"
            element={<DeminimisAddPage role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Podrobnosti/:id"
            element={<DeminimisDetailsPage role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Projekti/Podrobnostiv2/:id"
            element={<ProjectDetailsV2 role={role} />}
          >
            <AuthorizedRoute
              index
              element={<Navigate to="splosno" replace />}
            />
            <AuthorizedRoute path="Splosno" element={<Splosno />} />
            <AuthorizedRoute path="Partnerstvo" element={<Partnerstvo />}>
              <AuthorizedRoute
                index
                element={<Navigate to="partnerske-organizacije" replace />}
              />
              <AuthorizedRoute
                path="partnerske-organizacije"
                element={<PartnerskeOrganizacije />}
              />
              <AuthorizedRoute
                path="sodelovanje-znotraj-um"
                element={<SodelovanjeZnotrajUM />}
              />
            </AuthorizedRoute>
            <AuthorizedRoute path="Finance" element={<Finance />}>
              <AuthorizedRoute
                index
                element={<Navigate to="nacrtovana-vrednost-projekta" replace />}
              />
              <AuthorizedRoute
                path="nacrtovana-vrednost-projekta"
                element={<NacrtovanaVrednostProjekta />}
              />
              <AuthorizedRoute
                path="realizirana-vrednost-projekta"
                element={<RealiziranaVrednostProjekta />}
              />
              <AuthorizedRoute
                path="stroskovna-mesta"
                element={<StroskovnaMesta />}
              />
              <AuthorizedRoute
                path="deminimis"
                element={<DeminimisProjectDetails />}
              />
            </AuthorizedRoute>
          </AuthorizedRoute>
          <AuthorizedRoute
            exact
            path="/Deminimis"
            element={<Deminimis role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Skrbnistvo"
            element={<Deminimis role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Dodaj"
            element={<DeminimisAddPage role={role} />}
          />
          <AuthorizedRoute
            exact
            path="/Deminimis/Podrobnosti/:id"
            element={<DeminimisDetailsPage role={role} />}
          />
        </Routes>
      );
      break;
    default:
      break;
  }
  return <Col>{routes}</Col>;
};

export default AuthorisationComponent;
